import { COLORS } from '~/data/ui/colors';
import theme from '~/theme';

export const useStyles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginBottom: '60px',
    [theme.breakpoints.up('md')]: {
      minWidth: '580px',
      maxWidth: '580px',
      marginBottom: '0px',
      height: '650px',
    },
  },
  container: {
    border: `1px solid ${COLORS.gray.main}`,
    maxWidth: '100%',
    borderRadius: '4px',
    padding: '24px',
    gap: '30px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  iconStyle: {
    marginLeft: '18px',
  },
  imageWidget: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '50px',
  },
  inputStyle: {
    width: '100%',

    '& .MuiInputBase-root': {
      height: '50px',
      borderRadius: '8px',
    },
  },
  inputNoteStyle: {
    width: '100%',

    '& .MuiInputBase-root': {
      height: '100px',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'flex-start',
    },
  },
  checkboxesContainer: {
    display: 'flex',
    flexDirection: 'column',

    gap: '5px',
    paddingTop: '10px',
    '&.paddingTopLarger': {
      paddingTop: '22px',
    },
  },
};

export const helperTextStyle = {
  '& .MuiFormHelperText-root': {
    textAlign: 'right',
    position: 'absolute',
    bottom: '-22px',
    marginRight: '1px',
  },
};

export const ContactUsSuccessPageTitleMobile = {
  fontSize: ' 30px',
  fontWeight: '600',
  lineHeight: ' 25px',
  fontFamily: 'EricaSansFOT',
};

export const ContactUsSuccessPageTitleDesktop = {
  fontSize: ' 34px',
  fontWeight: '600',
  lineHeight: ' 25px',
  fontFamily: 'EricaSansFOT',
};
export const ContactUsSuccessPageDescDesktop = {
  fontSize: ' 20px',
};
export const ContactUsSuccessPageDescMobile = {
  fontSize: ' 18px',
};
export const leaveDetailsButtonStyle = {
  width: '100%',
  minHeight: '45px',
  marginTop: '20px',
};
